// Shared style tokens for the finance module's pages — one token file so
// every finance page stays visually consistent with the rest of VEC MS
// (Students.css's light palette) without any page repeating its own inline
// colour literals.

export const colors = {
  bg: 'transparent',
  card: '#fff',
  cardBorder: '#e2e8f0',
  input: '#fff',
  inputBorder: '#e0e0e0',
  text: '#334155',
  textBright: '#1e293b',
  textDim: '#64748b',
  textFaint: '#94a3b8',
  textGhost: '#cbd5e1',
  blue: '#4facfe',
  green: '#43e97b',
  amber: '#f5a623',
  red: '#f5576c',
  purple: '#011ff3',
};

export const page = { minHeight: '100vh', background: colors.bg, color: colors.text, padding: '28px 32px' };

export const pageHeader = { marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 };

export const pageTitle = { margin: 0, fontSize: 24, fontWeight: 700, color: colors.textBright, display: 'flex', alignItems: 'center', gap: 10 };

export const pageSubtitle = { margin: '6px 0 0', color: colors.textFaint, fontSize: 14, maxWidth: 640 };

export const card = { background: colors.card, border: `1px solid ${colors.cardBorder}`, borderRadius: 12, padding: '16px 20px' };

export const statCard = { ...card, minWidth: 190, padding: '14px 18px' };

export const iconButton = { padding: '9px 12px', borderRadius: 8, border: `1px solid ${colors.cardBorder}`, background: colors.input, color: colors.textDim, cursor: 'pointer', display: 'flex', alignItems: 'center' };

export const primaryButton = { padding: '9px 16px', borderRadius: 8, border: `1px solid ${colors.purple}`, background: 'rgba(1, 31, 243,0.12)', color: colors.purple, cursor: 'pointer', fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 };

export const dangerButton = { padding: '7px 12px', borderRadius: 7, border: '1px solid rgba(245,87,108,0.35)', background: 'rgba(245,87,108,0.1)', color: colors.red, cursor: 'pointer', fontSize: 12, fontWeight: 600 };

export const successButton = { padding: '7px 12px', borderRadius: 7, border: '1px solid rgba(67,233,123,0.3)', background: 'rgba(67,233,123,0.08)', color: colors.green, cursor: 'pointer', fontSize: 12, fontWeight: 600 };

export const neutralButton = { padding: '7px 12px', borderRadius: 7, border: `1px solid ${colors.cardBorder}`, background: colors.input, color: colors.textDim, cursor: 'pointer', fontSize: 12 };

export const input = { background: colors.input, border: `1px solid ${colors.inputBorder}`, borderRadius: 8, color: colors.text, padding: '9px 12px', fontSize: 13 };

export const select = { ...input };

export const label = { display: 'block', color: colors.textDim, fontSize: 12, fontWeight: 600, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' };

export const errorBanner = { background: 'rgba(245,87,108,0.07)', border: '1px solid rgba(245,87,108,0.2)', borderRadius: 10, padding: '14px 18px', color: colors.red, fontSize: 14, display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 };

export const tableWrap = { background: colors.card, border: `1px solid ${colors.cardBorder}`, borderRadius: 12, overflow: 'hidden' };

export const table = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };

export const tableHeadRow = { background: colors.input, borderBottom: `1px solid ${colors.cardBorder}` };

export const th = { padding: '12px 14px', textAlign: 'left', color: '#444', fontWeight: 600, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.07em' };

export const td = { padding: '12px 14px', color: colors.textDim };

export const emptyState = { textAlign: 'center', padding: '100px 0', color: colors.textGhost };

export const loadingState = { textAlign: 'center', padding: '80px 0', color: colors.textGhost, fontSize: 14 };

export const badge = (color) => ({
  background: color + '22', color, border: `1px solid ${color}`, borderRadius: 8,
  padding: '2px 8px', fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
});

export const money = (v, currency = '') => {
  if (v === null || v === undefined || v === '') return '—';
  const n = parseFloat(v);
  const formatted = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${formatted} ${currency}` : formatted;
};

export const STATUS_COLORS = {
  DRAFT: '#888', SUBMITTED: '#f5a623', PENDING: '#f5a623', PENDING_APPROVAL: '#f5a623',
  POSTED: '#43e97b', APPROVED: '#43e97b', ISSUED: '#43e97b', SUCCEEDED: '#43e97b', PAID: '#43e97b', CLOSED: '#43e97b',
  REJECTED: '#f5576c', FAILED: '#f5576c', CANCELLED: '#f5576c', VOID: '#666',
  OPEN: '#00c6fb', LOCKED: '#f5576c',
};
